import { ActionTree } from 'vuex';
import {
  ERecipientAction,
  ERecipientMutation,
} from '@/document-edit/assembler/recipients/store/recipient.constants';
import { RootState } from '@/store/store';
import { IRecipientState } from '@/document-edit/assembler/recipients/store/recipient.types';
import { IRecipient } from '@lib-shared/types/Recipient';
import { translate } from '@/helpers/translation.helper';
import bugsnagClient from '@lib-shared/bugsnag';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';
import { RecipientService } from '@/api/recipients/services/recipient.service';

export const actions: ActionTree<IRecipientState, RootState> = {
  [ERecipientAction.SetModalVisibility]({ commit }, show: boolean) {
    commit(ERecipientMutation.SetModalVisibility, show);
  },
  [ERecipientAction.SetIsLoading]({ commit }, isLoading: boolean) {
    commit(ERecipientMutation.SetIsLoading, isLoading);
  },
  async [ERecipientAction.SearchRecipientToAssign](
    { dispatch, commit },
    { search, documentId }: { search: string; documentId: string }
  ) {
    try {
      const recipientList: IRecipient[] = await RecipientService.searchRecipient(
        search,
        documentId
      );
      commit(ERecipientMutation.UpdateSearchRecipientResult, recipientList);
    } catch (error) {
      if (bugsnagClient) {
        bugsnagClient.notify(error);
      }
      dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('could-not-load-list'), {
        root: true,
      });
    }
  },
  async [ERecipientAction.OpenRecipientToRoleModal]({ dispatch }, recipientId: string) {
    try {
      const recipient: IRecipient = await RecipientService.getRoleDetails(recipientId);
      dispatch(ERecipientAction.SetRecipientModalInfo, recipient);
    } catch (error) {
      if (bugsnagClient) {
        bugsnagClient.notify(error);
      }
      dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('something-went-wrong'), {
        root: true,
      });
    }
  },
  [ERecipientAction.SetRecipientModalInfo]({ commit }, recipient: IRecipient) {
    commit(ERecipientMutation.UpdateEditRecipient, recipient);
  },
};
